import Request from '~/providers/Request';

export const fetchCountries = async (input, page, resolve) => {
  await Request.get(`/admin/countries`).then(resp => {
    const items = resp.data.map( e => ({
      id: Number(e.id),
      name: `${e.name}`
    }));
    resolve(
      {
        total_count: resp.meta.total,
        items
      }
    );
  });
};
